import React, { useEffect } from 'react'
import { useSnapshot } from 'valtio'
import { UserState } from '@app/storage'
import { FeedbackEvent, useFeedbackRequest, useFeedbackSubmit } from '@app/helpers'
import StudentFeedbackView from './StudentFeedbackView'

interface Props {
  event: FeedbackEvent
  testName: string
  onSubmitCallback?: (
    submitFn: () => Promise<boolean>,
    isCombined: boolean,
    hasRating: boolean
  ) => void
}

const StudentFeedbackModalContent: React.FC<Props> = ({ event, testName, onSubmitCallback }) => {
  const { user } = useSnapshot(UserState)

  const { loading, feedbackPrompt } = useFeedbackRequest(user, event, { testName })

  const {
    selectedRate,
    onChangeFeedbackRating,
    openResponse,
    setOpenResponse,
    submitted,
    submitFeedback,
    isCombinedFeedback,
    hasRatingToSubmit
  } = useFeedbackSubmit(feedbackPrompt)

  useEffect(() => {
    if (onSubmitCallback) {
      onSubmitCallback(submitFeedback, isCombinedFeedback, hasRatingToSubmit)
    }
  }, [onSubmitCallback, submitFeedback, isCombinedFeedback, hasRatingToSubmit])

  if (loading || !feedbackPrompt || !feedbackPrompt?.showPrompt) {
    return <></>
  }

  return (
    <StudentFeedbackView
      selectedRate={selectedRate}
      feedbackText={feedbackPrompt?.promptText}
      feedbackType={feedbackPrompt?.promptType}
      openResponse={openResponse}
      setOpenResponse={setOpenResponse}
      onChangeFeedbackRating={onChangeFeedbackRating}
      disabled={submitted}
    />
  )
}

export default StudentFeedbackModalContent
